import { z } from 'zod/v4';

/**
 * `POST /api/audits/:id/cancel-request` response: the audit whose access
 * request was withdrawn. The legacy route answered 200 with an empty body,
 * which no caller read.
 */
export const CancelAuditRequestResponseSchema = z.object({
  auditId: z.string(),
  status: z.literal('CANCELED'),
});

export type CancelAuditRequestResponse = z.infer<
  typeof CancelAuditRequestResponseSchema
>;
